import axios from 'axios';
import authHeader from "@/service/auth-header";

class ProcessService {

    getCompanyProcesses(companyId) {
        return axios.get(`/api/process/${companyId}`, {headers: authHeader()})
    }

    searchCompanyProcesses(companyId, processName) {
        return axios.get(`/api/process/${companyId}/${processName}`, {headers: authHeader()})
    }

    getProcess(processId) {
        return axios.get(`/api/process/specific/${processId}`, {headers: authHeader()})
    }

    createProcess(companyId, data) {
        return axios.post(`/api/process/${companyId}`, data, {headers: authHeader()});
    }

    updateProcess(processId, data) {
        return axios.put(`/api/process/${processId}`, data, {headers: authHeader()});
    }

    deleteProcess(processId) {
        return axios.delete(`/api/process/${processId}`,{ headers: authHeader() })
    }

}

export default new ProcessService();
